module.exports = __webpack_public_path__ + "img/下部轮廓.d5efab40.png";